/* eslint-disable react/function-component-definition */
import PropTypes from 'prop-types';
import { components } from 'react-select';

import { Box } from '@hivebrite/design-system/Box';
import { IconClose } from '@hivebrite/design-system/Icon';

import { Select } from 'hb-react/shared/components/formik/components/inputs';

const CustomOptionComponent =
  ({ onDelete, undeletable = [] }) =>
  ({ children, data, ...rest }) => (
    <components.Option data={data} {...rest}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        css="color: inherit"
        data-testid="react-select-option"
      >
        <Box css="color: inherit">{children}</Box>
        {!(undeletable || []).includes(data.label) && (
          <Box css="color: inherit">
            <span
              data-testid="deleteOption"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                onDelete(data);
              }}
            >
              <IconClose size={12} />
            </span>
          </Box>
        )}
      </Box>
    </components.Option>
  );

const GuestSelect = ({ undeletable, guestsOptions, onDelete, ...rest }) => (
  <Select
    placeholder={__('Select attendee')}
    label={__('Choose attendee')}
    validate={{
      required: true,
    }}
    options={guestsOptions}
    inputHtml={{
      components: {
        Option: CustomOptionComponent({
          onDelete,
          undeletable,
        }),
      },
    }}
    {...rest}
  />
);

GuestSelect.propTypes = {
  undeletable: PropTypes.array,
  guestsOptions: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default GuestSelect;
